import React from 'react'
import { Form, Input } from 'antd'

type ManualExternalInputsProps = {
  /** Extra fields rendered between Name and External ID (e.g. State's external country id). */
  extra?: React.ReactNode
}

/**
 * The fallback external target — a plain Name + External ID pair, used when there's
 * no Shelter Buddy list to pick from (non-SB partner, or a mapping type without an
 * external picker).
 */
export const ManualExternalInputs = ({ extra }: ManualExternalInputsProps) => (
  <>
    <Form.Item
      label="Name"
      name="name"
      rules={[{ required: true, message: 'Missing a name' }]}
    >
      <Input />
    </Form.Item>
    {extra}
    <Form.Item
      label="External ID"
      name="external_id"
      rules={[{ required: true, message: 'Missing an external id' }]}
    >
      <Input />
    </Form.Item>
  </>
)
